// extracted by mini-css-extract-plugin
export default {"container":"RemoteAccess_container__KqUFt"};